
const  saveCountry = async (name, code ) => {
    try {
        const data = { name, code };
        const response = await axios.post( "/location/country", data );
        return {created : true, message: response.data.message};
    } catch (error) {
        console.log("Error al guardar los datos", error);
        return {created : false, message: error.response.data.message};
    }
}

const saveState = async (country, code, state) => {
    try {
        const name = state;
        const statesCode = code;
        const country_id = country.id;
        const data = { name, statesCode, country_id }
        const response = await axios.post( "/location/state", data );
        return {created : true, message: response.data.message};
    } catch (error) {
        console.log("Error al guardar los datos", error);
        return {created : false, message: error.response.data.message};
    }
};

const saveCity = async (state, city) => {
    try {
        const name = city;
        const state_id = state.id;
        const data = { name, state_id }
        const response = await axios.post( "/location/city", data );
        return {created : true, message: response.data.message};
    } catch (error) {
        console.log("Error al guardar los datos", error);
        return {created : false, message: error.response.data.message};
    }
};

const deleteCity = async (id) => {
    try {
        const response = await axios.delete(`/locationResources/${id}`)
        return {deleted : true, message: response.data.message};
    } catch (error) {
        console.log("Error al eliminar los datos", error);
        return {deleted : false, message: error.response.data.message};
    }
};

const getCity = async (id) => {
    try {
        const response = await axios.get(`/locationResources/${id}`);
        return {data : response.data};
    } catch (error) {
        console.log("Error al obtener los datos", error);
        return {data : null, message: error.response.data.message};
    }
};

const updateCity = async (city, city_id) => {
    try {
        const data = { city, city_id };
        const response = await axios.put(`/locationResources/${city_id}`, data);
        return {updated : true, message: response.data.message};
    } catch (error) {
        console.log("Error al actualizar los datos", error);
        return {updated : false, message: error.response.data.message};
    }
};

export { saveCountry, saveState, saveCity, deleteCity, getCity, updateCity };